import { usePerpsOrderbook } from "#/store/perps/page/perpsOrderbook";
import { usePerpIsBuy } from "#/store/perps/tradePanel/perpIsBuy";
import { usePerpLimitPrice } from "#/store/perps/tradePanel/perpLimitPrice";
import { usePerpSize } from "#/store/perps/tradePanel/perpSize";
import { type EstimatedExecPriceProps } from "#/types/fees";
import {
  CalculatedExecPrice,
  calculateEstimatedExecutionPrice,
  execPriceDefaultValues,
} from "#/utils/estimatedExecPrice.utils";

export const useCalcPerpsMarketExecPrice = ({
  type,
  kind,
}: EstimatedExecPriceProps): CalculatedExecPrice => {
  const { perpSizeNum } = usePerpSize();
  const { perpLimitPrice } = usePerpLimitPrice();
  const { perpsOrderbook } = usePerpsOrderbook();
  const { perpIsBuy } = usePerpIsBuy();
  const isMissingDetails = !perpSizeNum || !perpLimitPrice;

  if (type !== "market" || kind !== "perps" || isMissingDetails)
    return execPriceDefaultValues;

  return calculateEstimatedExecutionPrice(perpSizeNum, {
    bids: perpsOrderbook.buys,
    asks: perpsOrderbook.sells,
    isBuy: perpIsBuy,
  });
};
